import { saInterfaceExpertPost } from "../saTypes"
import * as React from "react"
import SaImage from "../saImage/saImage"

// @ts-ignore
import { saExpertsSliderItem, saLink, saExpertsSliderItemInner, saExpertsSliderItemImage, saExpertsSliderItemPosition, saExpertsSliderItemName, saExpertsSliderItemLogo } from './saExperts.module.scss'

export const SaExpertsList:React.FC<Array<saInterfaceExpertPost>> = ({...props}) =>{



  let listSlides = Object.values(props).map((item:saInterfaceExpertPost, index) => (

            <div key={index} className={saExpertsSliderItem}>
              <div className={saLink}>

                <div className={saExpertsSliderItemInner}>



                  {
                    item.saExpertDetails && item.saExpertDetails.expertDetails.photo &&
                    <div className={saExpertsSliderItemImage}>
                      <SaImage {...item.saExpertDetails.expertDetails.photo}/>
                    </div>
                  }

                  {
                    item.saExpertDetails && item.saExpertDetails.expertDetails.position &&
                    <div className={saExpertsSliderItemPosition}
                         dangerouslySetInnerHTML={{__html: item.saExpertDetails.expertDetails.position}}/>
                  }

                  <div className={saExpertsSliderItemName}
                       dangerouslySetInnerHTML={{__html: item.title}}/>

                  {
                    item.saExpertDetails && item.saExpertDetails.expertDetails.logo &&
                    <div className={saExpertsSliderItemLogo}>
                      <SaImage {...item.saExpertDetails.expertDetails.logo}/>
                    </div>
                  }

                </div>

              </div>
            </div>

      )
  )

  return (
    <>{ listSlides }</>
  )
}